import { baseOssUrl } from "@/util/config";
import { getLuckDrawConfigure, getLuckDrawResult } from "@/util/data";
import PrizeDetail from "@/components/LuckDraw/PrizeDetail";
import Base from "@/components/LuckDraw/Base";

const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export const LuckDrawMixin = {
  components: {
    PrizeDetail,
    Base
  },
  data() {
    return {
      showLoading: false,
      chance: 0,
      result: {},
      detail: {},
      myAwards: [],
      baseSize,
      baseOssUrl,
    }
  },
  mounted() {
    this.getPrizesList();
    window.document.documentElement.style.fontSize = 20 * baseSize + "px";
  },
  computed: {
    resultState() {
      return this.$store.state.showResult;
    },
    messageState() {
      return this.$store.state.showMessage;
    },
    userDetail() {
      return this.$store.state.userDetail;
    }
  },
  watch: {
    resultState(newVal) {
      if (!newVal) this.init();
    },
    messageState(newVal) {
      if (!newVal) this.init();
    },
    userDetail(newVal) {
      if (newVal) this.getPrizesList();
    }
  },
  methods: {
    init() { },
    checkLogin() {
      let token = this.$store.state.token || window.localStorage.getItem("token");
      if (!token) {
        this.$store.commit("updateLoginState", true);
        return false;
      }
      return true;
    },
    getPrizesList() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token") || "";
      getLuckDrawConfigure(
        {
          id: this.$route.params.id
        },
        token
      ).then(res => {
        if (res.code === 1 && res.data) {
          this.handleData({ ...res.data });
        }
      })
        .catch(err => {
        });
    },
    getResult() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      getLuckDrawResult(
        {
          activity_id: this.$route.params.id
        },
        token
      )
        .then(res => {
          if (res.code === 1 && res.data && res.data.award) {
            this.handleResult(res.data)
          } else {
            this.showLoading = false;
            this.handleError();
            this.showMessage(res.msg || "Failed!");
          }
        })
        .catch(err => {
          const msg = typeof err === "object" ? JSON.stringify(err) : err;
          this.showMessage(msg === "{}" || !msg ? "Failed!" : msg);
          this.showLoading = false;
          this.handleError();
        });
    },
    handleError() {

    },
    getImageByPrizeId(id) {
      let imageUrl = "";
      this.defaultPrize.forEach(item => {
        if (item.id == id) {
          imageUrl = item.image; }
      })
      return imageUrl;
    },
    showMessage(text) {
      this.$store.commit("updateValue", ["showMessage", true]);
      this.$store.commit("updateValue", ["messageContent", text]);
    },
    showResult(obj) {
      this.$store.commit("updateValue", ["showResult", true]);
      this.$store.commit("updateValue", ["prizeResult", { ...obj }]);
    }
  },
}


// WEBPACK FOOTER //
// ./src/mixins/Luckdraw.js